module.exports = __webpack_public_path__ + "components/app-promo/static/intersport/4-83ed7c3abe675ac91945809a0b939931.png";